/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-plusplus */
/* eslint-disable radix */
/* eslint-disable max-len */
import { http, layout } from '.';
import { date, extract, format, } from './utils';
import { applyUrlFilters, resolveHideKeys } from './report-filter';

export const report = {
  brands: [
    'agrale',
    'alfa romeo',
    'audi',
    'bmw',
    'caoachery',
    'caoa chery',
    'chery',
    'chevrolet',
    'chev',
    'chrysler',
    'citroen',
    'dafra',
    'daf',
    'dodge',
    'ferrari',
    'fiat',
    'ford',
    'gm',
    'gmc',
    'harley',
    'harley-david',
    'harley-davids',
    'harley-davidson',
    'h.davidson',
    'honda',
    'hyundai',
    'infiniti',
    'iveco',
    'jac',
    'jag',
    'jaguar',
    'jeep',
    'kasinski',
    'kawasaki',
    'kia',
    'lamborghini',
    'lancia',
    'lr',
    'land rover',
    'lexus',
    'lifan',
    'mazda',
    'man',
    'm/benz.accelo',
    'm/benz',
    'm.benz',
    'mercedes benz',
    'mercedes-benz',
    'mg',
    'mini',
    'mmc',
    'mitsubishi',
    'nissan',
    'not found',
    'opel',
    'peugeot',
    'porsche',
    'ram',
    'randon',
    'renault',
    'royal enfield',
    'royal',
    'scania',
    'seat',
    'shineray',
    'smart',
    'skoda',
    'subaru',
    'suzuki',
    'toyota',
    'triumph',
    'troller',
    'volkswagen',
    'volvo',
    'vw',
    'yamaha',
  ],
  bandImage: {
    agrale: 'agrale.png',
    'alfa romeo': 'alfa-romeo.png',
    audi: 'audi.png',
    bmw: 'bmw.png',
    'caoa chery': 'chery.png',
    'caoachery': 'chery.png',
    chery: 'chery.png',
    chevrolet: 'chevrolet.png',
    chev: 'chevrolet.png',
    chrysler: 'chrysler.png',
    citroen: 'citroen.png',
    dafra: 'dafra.png',
    daf: 'daf.png',
    dodge: 'dodge.png',
    ferrari: 'ferrari.png',
    fiat: 'fiat.png',
    ford: 'ford.png',
    gm: 'chevrolet.png',
    gmc: 'gmc.png',
    harley: 'harley-davidson.png',
    'harley david': 'harley-davidson.png',
    'harley davids': 'harley-davidson.png',
    'harley davidson': 'harley-davidson.png',
    'h.davidson': 'harley-davidson.png',
    honda: 'honda.png',
    'honda motorcycle': 'honda-motorcycle.png',
    hyundai: 'hyundai.png',
    infiniti: 'infiniti.png',
    iveco: 'iveco.png',
    jac: 'jac.png',
    jag: 'jaguar.png',
    jaguar: 'jaguar.png',
    jeep: 'jeep.png',
    kasinski: 'kasinski.png',
    kawasaki: 'kawasaki.png',
    kia: 'kia.png',
    lamborghini: 'lamborghini.png',
    lancia: 'lancia.png',
    lr: 'land-rover.png',
    'land rover': 'land-rover.png',
    lexus: 'lexus.png',
    lifan: 'lifan.png',
    mazda: 'mazda.png',
    man: 'man.png',
    'm/benz.accelo': 'mercedes-benz.png',
    'm.benz': 'mercedes-benz.png',
    'mercedes benz': 'mercedes-benz.png',
    'mercedes-benz': 'mercedes-benz.png',
    mg: 'mg.png',
    mini: 'mini.png',
    mmc: 'mitsubishi.png',
    mitsubishi: 'mitsubishi.png',
    nissan: 'nissan.png',
    'not found': 'not-found.png',
    opel: 'opel.png',
    peugeot: 'peugeot.png',
    porsche: 'porsche.png',
    ram: 'ram.png',
    randon: 'randon.png',
    renault: 'renault.png',
    royal: 'royal-enfield.png',
    'royal enfield': 'royal-enfield.png',
    scania: 'scania.png',
    seat: 'seat.png',
    shineray: 'shineray.png',
    smart: 'smart.png',
    skoda: 'skoda.png',
    subaru: 'subaru.png',
    suzuki: 'suzuki.png',
    toyota: 'toyota.png',
    triumph: 'triumph.png',
    troller: 'troller.png',
    volkswagen: 'volkswagen.png',
    volvo: 'volvo.png',
    vw: 'volkswagen.png',
    yamaha: 'yamaha.png',
  },
  inquiry: (code, input, value, flowId, callback) => {
    layout.loading(true);
    const flow = flowId ? `/${flowId}` : '';
    http.get(`/histories/product/${input}/${value}${flow}?productCode=${code}`, (result, resultError, status) => {
      layout.loading(false);
      callback(value, result, resultError, status);
    });
  },
  configure: (items) => {
    if (items.length === 0 || !items[0]._id) {
      return {};
    }
    const data = items[0];
    const user = data.user || {};
    const configBase = {
      report: {
        hide: [],
      },
    };
    const config = data.product ? data.product.config || configBase : configBase;
    if (user.config?.report?.hide) {
      for (const hide of user.config.report.hide) {
        config.report.hide.push(hide);
      }
    }
    const brokenItems = data.issues ? data.issues.brokenItems ?? [] : [];
    const broken = (data.result?.body?.servicesBroken && data.result.body.servicesBroken.filter((e) => ![50, 61, 89, 101, 135].includes(e.serviceCode)).length > 0) || !!data.reprocess || (data.status === 'PROCESSING' && data.reprocessAttempts > 0);
    const item = {
      id: data._id,
      plate: data.plate || '',
      chassis: data.chassis || '',
      document: data.document || '',
      number: data.number || '',
      inquiry: data.product || data.inquiry || {},
      userId: data.userId || '',
      flowId: data.flowId || '',
      productId: data.productId || '',
      product: data.product || {},
      transfer: data.product?.transfer ?? false,
      type: data.type,
      result: data.result || {},
      executedAt: new Date(data.executedAt).toISOString(),
      value: extract.history.value(data),
      partner: data.partner || false,
      logo: user.logo || user.config?.logo || '',
      backgroundColor: user.backgroundColor || user.config?.backgroundColor || '',
      foregroundColor: user.foregroundColor || user.config?.foregroundColor || '',
      config: config.report,
      name: user.name || '',
      broken,
      brokenItems,
      chargeback: !!data.chargeback,
      model: data.model || '',
      photos: data.photos || [],
      finish: data.finish || '',
      optional: data.optional,
      unlocked: data.unlocked,
      status: data.status,
    };
    if ('prospects@aboutcar.com.br' === data.user?.email) {
      item.notCharged = true;
    }
    if (data.user?.partner && data.user?.prepaid && !data.user?.validated) {
      item.partner = false;
    }
    if (item.plate || item.chassis || (data.productId && (data.product.code === 'BUSCAPORVEICULOS' || data.product.code === 'VEICULOSPORCPF'))) {
      report.vehicle(item);
    } else if (item.document && item.product?.category === 'CREDIT' && !item.result?.body) {
      report.credit(item);
    } else if (item.document && (!data.productId || (data.product.code !== 'BUSCAPORVEICULOS' && data.product.code !== 'VEICULOSPORCPF'))) {
      report.person(item);
    }
    return item;
  },
  credit: (item) => {
    item.credit = item.result?.data || {};
    if (item.credit.bestInfo) {
      item.credit.quod = true;
    }
    if (item.credit.registration) {
      item.credit.serasa = true;
      if (item.credit.registration.consumerName && !item.credit.registration.consumerDocument) {
        item.credit.registration.consumerDocument = item.document;
      }
    }
  },
  person: (item) => {
    item.person = item.result?.body?.data || {};
    if (item.person.dadosCadastrais || item.person.pendenciasFinanceiras) {
      item.person.checktudo = true;
    } else {
      item.person.veles = true;
    }
    item.person.pendencias = {
      financeiras: false,
      cheques: false,
      protesto: false,
      debitosTrabalhistas: false,
      itens: [],
      resumo: [{
        descricao: 'Pendências Financeiras',
        quantidade: 0,
        valor: 0,
        dataPrimeira: '',
        dataUlima: '',
      }, {
        descricao: 'Cheques sem Fundo',
        quantidade: 0,
        valor: 0,
        dataPrimeira: '',
        dataUlima: '',
      }],
    };
    if (item.person.debitosTrabalhistas?.date) {
      item.person.pendencias.debitosTrabalhistas = true;
    }
    if (item.person.pendenciasFinanceiras) {
      let dataPrimeira = 0;
      let dataUltima = 0;
      const datas = (element) => {
        if (dataPrimeira === 0 || dataPrimeira > date.convert(element.dataOcorrencia)) {
          dataPrimeira = date.convert(element.dataOcorrencia);
          item.person.pendencias.resumo[0].dataPrimeira = element.dataOcorrencia;
        }
        if (dataUltima === 0 || dataUltima < date.convert(element.dataOcorrencia)) {
          dataUltima = date.convert(element.dataOcorrencia);
          item.person.pendencias.resumo[0].dataUltima = element.dataOcorrencia;
        }
      };
      const getValor = (element) => {
        let valor = element.valorPendencia || element.valor;
        if (typeof (valor) === 'string') {
          valor = Number.parseFloat(valor.replace('R$', '').replace(/\s/g, '').replace(/\./g, '').replace(',', '.'));
        }
        item.person.pendencias.resumo[0].valor += valor;
        return valor;
      };
      const adicionar = (element) => {
        datas(element);
        item.person.pendencias.itens.push({
          data: element.dataOcorrencia,
          contrato: element.contrato,
          credor: element.credor || element.origem || '',
          cidade: element.cidade || '',
          valor: getValor(element),
          avalista: element.avalista || '',
        });
      };
      if (item.person.pendenciasFinanceiras?.pefin?.quantidade) {
        item.person.pendencias.resumo[0].quantidade += item.person.pendenciasFinanceiras.pefin.quantidade;
        item.person.pendenciasFinanceiras.pefin.detalhes.forEach((element) => adicionar(element));
      }
      if (item.person.pendenciasFinanceiras?.refin?.quantidade) {
        item.person.pendencias.resumo[0].quantidade += item.person.pendenciasFinanceiras.refin.quantidade;
        item.person.pendenciasFinanceiras.refin.detalhes.forEach((element) => adicionar(element));
      }
      if (item.person.pendenciasFinanceiras?.scpc?.quantidade) {
        item.person.pendencias.resumo[0].quantidade += Number.parseInt(item.person.pendenciasFinanceiras.scpc.quantidade);
        item.person.pendenciasFinanceiras.scpc.registros.forEach((element) => adicionar(element));
      }
      if (item.person.pendenciasFinanceiras?.scpcBvs?.quantidade) {
        item.person.pendencias.resumo[0].quantidade += Number.parseInt(item.person.pendenciasFinanceiras.scpcBvs.quantidade);
        item.person.pendenciasFinanceiras.scpcBvs.registros.forEach((element) => adicionar(element));
      }
      if (item.person.pendencias.resumo[0].quantidade > 0) {
        item.person.pendencias.financeiras = true;
      }
    }
    if (item.person.ccf?.detalhes && item.person.ccf.detalhes.length > 0) {
      item.person.pendencias.resumo[1].quantidade = item.person.ccf.detalhes.length;
      item.person.pendencias.cheques = true;
    }
    if (item.person.protesto?.quantidade && item.person.protesto.quantidade > 0) {
      item.person.pendencias.protesto = true;
    }
    if (item.person.scorePfPj) {
      item.person.scoreAcerta = {
        score: item.person.scorePfPj,
      };
    }
    if (item.person.telefones && item.person.telefones.length > 0) {
      item.person.telefones.forEach((element, index) => {
        if (!element.telefone) {
          item.person.telefones.splice(index, 1);
        }
      });
    }
    if (item.person.emails && item.person.emails.length > 0) {
      item.person.emails.forEach((element, index) => {
        if (!element.email) {
          item.person.emails.splice(index, 1);
        }
      });
    }
  },
  sex: (value) => {
    const sex = {
      m: 'Masculino',
      masculino: 'Masculino',
      f: 'Feminino',
      feminino: 'Feminino',
    };
    return value ? sex[value.toLowerCase()] : 'Nada Consta';
  },
  personImage: (value) => {
    if (!value) {
      return '/assets/images/sex/not-found.png';
    }
    if (value.bestInfo) {
      if (value.bestInfo.document.length > 11) {
        return '/assets/images/company.png';
      }
      if (value.bestInfo.gender === 'M') {
        return '/assets/images/sex/male.png';
      }
      return '/assets/images/sex/female.png';
    }
    if (value.razaoSocial) {
      return '/assets/images/company.png';
    }
    if (value.registration) {
      if (value.registration.companyName) {
        return '/assets/images/company.png';
      }
      return '/assets/images/sex/not-found.png';
    }
    const sex = {
      m: 'male.png',
      masculino: 'male.png',
      f: 'female.png',
      feminino: 'female.png',
    };
    return `/assets/images/sex/${value.sexo && sex[value.sexo.toLowerCase()] ? sex[value.sexo.toLowerCase()] : 'not-found.png'}`;
  },
  personScoreColor: (value) => {
    if (value >= 0 && value <= 300) {
      return '#ff120f';
    }
    if (value >= 300 && value <= 600) {
      return '#ffe308';
    }
    if (value >= 600 && value <= 1000) {
      return '#009b06';
    }
    return '#ff120f';
  },
  personScore2Color: (value) => {
    if (value >= 0 && value <= 30) {
      return '#ff120f';
    }
    if (value >= 30 && value <= 60) {
      return '#ffe308';
    }
    if (value >= 60 && value <= 100) {
      return '#009b06';
    }
    return '#ff120f';
  },
  owners: (vehicle) => {
    let total = 0;
    let owner = '';
    if (vehicle.baseEstadual?.pronome) {
      total += 1;
      owner = vehicle.baseEstadual.pronome;
    }
    if (vehicle.baseEstadual?.pronomeAnterior && owner !== vehicle.baseEstadual.pronomeAnterior) {
      total += 1;
    }
    if (vehicle.historicoProprietarios && vehicle.historicoProprietarios.length > 0) {
      total = vehicle.historicoProprietarios.length;
    }
    return total;
  },
  vehicle: (item) => {
    item.vehicle = item.result?.body?.data || {};
    item.vehicle.credit = item.result?.data || {};
    item.vehicle.person = item.result?.body?.data?.pessoa || {};
    if (item.type === 'TESTDRIVE') {
      if (!item.unlocked) {
        item.vehicle.chassi = '*****';
        item.vehicle.renavam = '*****';
        item.vehicle.motor = '*****';
        item.vehicle.numeroMotor = '*****';
        item.vehicle.numMotor = '*****';
        item.vehicle.caixaCambio = '*****';
      }
      delete item.vehicle.faturado;
      delete item.vehicle.ufFaturado;
      delete item.vehicle.procedencia;
      delete item.vehicle.tipoDocumentoFaturado;
      delete item.vehicle.tipoDocumentoImportadora;
      delete item.vehicle.tipoDocumentoProprietario;
      delete item.vehicle.linha;
      delete item.vehicle.placaModeloAntigo;
      delete item.vehicle.placaModeloNovo;
      delete item.vehicle.ufPlaca;
      delete item.vehicle.especie;
      delete item.vehicle.segmento;
      delete item.vehicle.subSegmento;
      delete item.vehicle.situacaoChassi;
    }
    const csv = 'CSV';
    if (item.product?.details && item.product?.details?.indexOf(csv) !== -1 && !item.vehicle.csv && item.brokenItems.indexOf(csv) === -1) {
      item.brokenItems.push(csv);
    }
    if (item.vehicle.anoFabricacao) {
      item.vehicle.idade = new Date().getFullYear() - Number.parseInt(item.vehicle.anoFabricacao);
    }
    report.riskAnalisys(item.vehicle);
    const {
      baseEstadual,
      baseNacional,
    } = item.vehicle;
    item.vehicle.restricoes = { gerais: [] };
    if (report.hasRestriction(item.vehicle.restricao1)) {
      item.vehicle.restricoes.gerais.push(item.vehicle.restricao1);
    }
    if (report.hasRestriction(item.vehicle.restricao2)) {
      item.vehicle.restricoes.gerais.push(item.vehicle.restricao2);
    }
    if (report.hasRestriction(item.vehicle.restricao3)) {
      item.vehicle.restricoes.gerais.push(item.vehicle.restricao3);
    }
    if (report.hasRestriction(item.vehicle.restricao4)) {
      item.vehicle.restricoes.gerais.push(item.vehicle.restricao4);
    }
    if (baseNacional) {
      item.vehicle.restricoes.nacional = report.hasAnyNationalRestriction(item.vehicle);
    }
    if (baseEstadual) {
      item.vehicle.restricoes.estadual = report.hasAnyStateRestriction(item.vehicle);
    }
    if (item.vehicle.decodificadorPrecificador && !item.vehicle.marcaModelo) {
      item.vehicle.marcaModelo = `${item.vehicle.decodificadorPrecificador.marca} / ${item.vehicle.decodificadorPrecificador.modelo}`;
    }
    if (item.vehicle.baseEstadual) {
      if (item.vehicle.baseEstadual.existeDebitoDpvat) {
        item.vehicle.baseEstadual.existeDebitoDpvat = item.vehicle.baseEstadual.existeDebitoDpvat.replace('NAO', 'NÃO').replace('DEBITO', 'DÉBITO').replace('0,00', '');
      }
      if (item.vehicle.baseEstadual.existeDebitoIpva) {
        item.vehicle.baseEstadual.existeDebitoIpva = item.vehicle.baseEstadual.existeDebitoIpva.replace('NAO', 'NÃO').replace('DEBITO', 'DÉBITO').replace('0,00', '');
      }
      if (item.vehicle.baseEstadual.existeDebitoLicenciamento) {
        item.vehicle.baseEstadual.existeDebitoLicenciamento = item.vehicle.baseEstadual.existeDebitoLicenciamento.replace('NAO', 'NÃO').replace('DEBITO', 'DÉBITO').replace('0,00', '');
      }
      if (item.vehicle.baseEstadual.existeDebitoMulta) {
        item.vehicle.baseEstadual.existeDebitoMulta = item.vehicle.baseEstadual.existeDebitoMulta.replace('NAO', 'NÃO').replace('DEBITO', 'DÉBITO').replace('0,00', '');
      }
      if (item.vehicle.baseEstadual.informacoesAvulsas && item.vehicle.baseEstadual.informacoesAvulsas.length > 0 && !item.partner) {
        for (let i = 0; i < item.vehicle.baseEstadual.informacoesAvulsas.length; ++i) {
          const informacao = item.vehicle.baseEstadual.informacoesAvulsas[i];
          if (informacao.descricao === 'PROPRIETARIO ANTERIOR') {
            item.vehicle.baseEstadual.informacoesAvulsas.splice(i, 1);
          }
        }
      }
    }
    const colors = [
      'rgb(54, 162, 235)',
      'rgb(75, 192, 192)',
      'rgb(201, 203, 207)',
      'rgb(255, 159, 64)',
      'rgb(153, 102, 255)',
      'rgb(255, 99, 132)',
      'rgb(255, 205, 86)',
    ];
    if (item.vehicle.dadosBasicosDoVeiculo?.informacoesFipe) {
      item.vehicle.chart = {
        line: {
          labels: [],
          datasets: [],
        },
        doughnut: {
          labels: [
            'Valor percentual sobre tabela FIPE',
            'Valor percentual para 100% tabela FIPE',
          ],
          datasets: [],
        },
      };
      item.vehicle.dadosBasicosDoVeiculo.informacoesFipe.forEach((element, index) => {
        item.vehicle.chart.line.datasets.push({
          label: `${element.marca}/${element.modelo} ${element.versao}`,
          fill: false,
          lineTension: 0.1,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: colors[index],
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: colors[index],
          pointBackgroundColor: '#fff',
          pointBorderWidth: 5,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: colors[index],
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [],
        });
        element.historicoPreco.forEach((subElement) => {
          if (index === 0) {
            item.vehicle.chart.line.labels.push(`${subElement.mes}/${subElement.ano}`);
          }
          item.vehicle.chart.line.datasets[index].data.push(subElement.valor);
        });
      });
    }
    if (item.vehicle.decodificadorPrecificador && item.vehicle.decodificadorPrecificador.precificadorI.length > 0) {
      const precificadorI = item.vehicle.decodificadorPrecificador.precificadorI[0];
      if (precificadorI.graphMes1) {
        item.vehicle.chart = {
          line: {
            labels: [
              precificadorI.graphMes12,
              precificadorI.graphMes11,
              precificadorI.graphMes10,
              precificadorI.graphMes9,
              precificadorI.graphMes8,
              precificadorI.graphMes7,
              precificadorI.graphMes6,
              precificadorI.graphMes5,
              precificadorI.graphMes4,
              precificadorI.graphMes3,
              precificadorI.graphMes2,
              precificadorI.graphMes1,
            ],
            datasets: [],
          },
          doughnut: {
            labels: [
              'Valor percentual sobre tabela FIPE',
              'Valor percentual para 100% tabela FIPE',
            ],
            datasets: [],
          },
        };
        item.vehicle.decodificadorPrecificador.precificadorI.map((fipe, index) => {
          item.vehicle.chart.line.datasets.push({
            label: fipe.modelo,
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: colors[index],
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: colors[index],
            pointBackgroundColor: '#fff',
            pointBorderWidth: 5,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: colors[index],
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [
              fipe.graphValor12,
              fipe.graphValor11,
              fipe.graphValor10,
              fipe.graphValor9,
              fipe.graphValor8,
              fipe.graphValor7,
              fipe.graphValor6,
              fipe.graphValor5,
              fipe.graphValor4,
              fipe.graphValor3,
              fipe.graphValor2,
              fipe.graphValor1,
            ],
          });
          return fipe;
        });
      }
    }

    if (item.vehicle.leilao?.score) {
      item.vehicle.leilao.score.cor = {
        1: '#009b06',
        2: '#ffe308',
        3: '#ff6a0c',
        4: '#ff120f',
      };
      item.vehicle.leilao.score.label = {
        1: 'Aparentemente inteiro',
        2: 'Pequenos danos',
        3: 'Médios danos',
        4: 'Grandes danos',
      };
      if (item.vehicle.leilao.score.aceitacao) {
        if (item.vehicle.leilao.score.aceitacao === 'NC') {
          item.vehicle.leilao.score.aceitacao = '';
        } else {
          item.vehicle.leilao.score.corAceitacao = '#009b06';
          if (item.vehicle.leilao.score.aceitacao < 90 && item.vehicle.leilao.score.aceitacao >= 70) {
            item.vehicle.leilao.score.corAceitacao = '#ffe308';
          } else if (item.vehicle.leilao.score.aceitacao < 70) {
            item.vehicle.leilao.score.corAceitacao = '#ff120f';
          }
        }
      }
      if (item.vehicle.leilao.score.percentualSobreRef) {
        if (item.vehicle.leilao.score.percentualSobreRef === 'NC') {
          item.vehicle.leilao.score.percentualSobreRef = '';
        } else {
          item.vehicle.leilao.score.corPercentual = '#009b06';
          if (item.vehicle.leilao.score.percentualSobreRef < 90 && item.vehicle.leilao.score.percentualSobreRef >= 70) {
            item.vehicle.leilao.score.corPercentual = '#ffe308';
          } else if (item.vehicle.leilao.score.percentualSobreRef < 70) {
            item.vehicle.leilao.score.corPercentual = '#ff120f';
          }

          if (item.vehicle.chart) {
            item.vehicle.chart.doughnut.datasets.push({
              data: [
                item.vehicle.leilao.score.percentualSobreRef,
                100 - item.vehicle.leilao.score.percentualSobreRef,
              ],
              backgroundColor: [
                'rgb(40, 167, 69)',
                colors[2],
              ],
              label: 'Percentual',
            });
          }
          item.vehicle.leilao.score.deg = 360 * (item.vehicle.leilao.score.percentualSobreRef / 100);
        }
      }
      if (item.vehicle.leilao.score.exigenciaVistoriaEspecial) {
        if (item.vehicle.leilao.score.exigenciaVistoriaEspecial === 'NC') {
          item.vehicle.leilao.score.exigenciaVistoriaEspecial = '';
          item.vehicle.leilao.score.labelExigenciaVistoriaEspecial = '';
        } else {
          item.vehicle.leilao.score.labelExigenciaVistoriaEspecial = 'pequena';
          if (item.vehicle.leilao.score.exigenciaVistoriaEspecial > 33) {
            item.vehicle.leilao.score.labelExigenciaVistoriaEspecial = 'razoável';
          }
          if (item.vehicle.leilao.score.exigenciaVistoriaEspecial > 66) {
            item.vehicle.leilao.score.labelExigenciaVistoriaEspecial = 'grande';
          }
        }
      }
    }
    if (item.transfer && item.vehicle.historicoProprietarios) {
      item.vehicle.historicoTransferencias = item.vehicle.historicoProprietarios;
      delete item.vehicle.historicoProprietarios;
    }
    if (item.productId) {
      return;
    }
    delete item.vehicle.debitosMultas;
    if (!item.productId) {
      delete item.vehicle.csv;
    }
    if (!item.partner) {
      delete item.vehicle.multasRenainf;
      delete item.vehicle.renajud;
      delete item.vehicle.renajuds;
      delete item.vehicle.gravame;
    }
    if (item.vehicle.historicoAnuncios && item.vehicle.historicoAnuncios.length > 0) {
      item.vehicle.anuncio = item.vehicle.historicoAnuncios[0];
    }
  },
  riskAnalisys: (vehicle) => {
    if (vehicle.analiseRisco || !vehicle.idade) {
      return;
    }
    vehicle.analiseRisco = {
      indiceRisco: '1',
      parecer: 'Veículo com baixo risco de recusa em comercialização/seguro 😃',
    };
    let valor = 0;
    if (vehicle.decodificadorPrecificador?.precificadorI[0]) {
      valor = parseFloat(vehicle.decodificadorPrecificador.precificadorI[0]);
    }
    if ((vehicle.idade > 5 && vehicle.idade < 10) || vehicle.nacionalidade !== 'NACIONAL' || valor > 180000) {
      vehicle.analiseRisco.indiceRisco = '2';
      vehicle.analiseRisco.parecer = 'Veículo com médio risco de recusa em comercialização/seguro 😑';
    }
    if (report.hasLeilao(vehicle) || report.hasIndicioSinistro(vehicle) || vehicle.idade > 10) {
      vehicle.analiseRisco.indiceRisco = '3';
      vehicle.analiseRisco.parecer = 'Veículo com alto risco de recusa em comercialização/seguro 😒';
    }
  },
  brandLogo: (value, logo) => {
    let name = 'not found';
    if (value.marcaModelo) {
      name = report.brands.find((element) => value.marcaModelo.indexOf(element.toUpperCase()) !== -1) || 'not found';
    } else if (value.dadosBasicosDoVeiculo?.marca) {
      name = value.dadosBasicosDoVeiculo.marca;
    } else if (value.decodificadorPrecificador?.marca) {
      name = value.decodificadorPrecificador.marca;
    }
    name = name.toLowerCase();
    if (name === 'honda' && value.tipoVeiculo && (value.tipoVeiculo.toLowerCase() === 'motocicleta' || value.tipoVeiculo.toLowerCase() === 'motoneta' || value.tipoVeiculo.toLowerCase() === 'motociclo')) {
      name += ' motorcycle';
    }
    if (name === 'not found' && logo) {
      return logo;
    }
    return `/assets/images/brands/${report.bandImage[name] || report.bandImage['not found']}`;
  },
  brand: (value) => {
    if (value.decodificadorPrecificador) {
      return `${value.decodificadorPrecificador.marca} / ${value.decodificadorPrecificador.modelo}`;
    }
    if (value.marcaModelo) {
      return value.marcaModelo;
    }
    return '';
  },
  semaphore: {
    1: '/assets/images/farol-verde.png',
    2: '/assets/images/farol-amarelo.png',
    3: '/assets/images/farol-vermelho.png',
  },
  riskColor: {
    1: 'green',
    2: 'rgb(255, 227, 8)',
    3: 'red',
  },
  type: (value) => {
    if (value.tipoCarroceria && ['INEXISTENTE', 'NADA CONSTA', 'NAO APLICAVEL', 'NAO INFORMADO', '0'].indexOf(format.upper(extract.normalize(value.tipoCarroceria))) === -1) {
      return value.tipoCarroceria.toLowerCase();
    }
    if (value.tipoVeiculo) {
      return value.tipoVeiculo.toLowerCase();
    }
    return 'N/D';
  },
  getVehicleCount: (value) => {
    if (value.result?.body?.data?.veiculos) {
      const quantity = value.result.body.data.veiculos.length;
      if (quantity === 0) {
        return 'Nenhum veículo encontrado';
      }
      return quantity > 1 ? `${quantity} veículos` : `${quantity} veículo`;
    }
    return '';
  },
  isBus: (value) => ['microonibus', 'micro onibus', 'onibus'].indexOf(value) !== -1,
  isCar: (value) => ['automovel', 'jipe', 'utilitario', 'furgao', 'camioneta', 'carroceria fechada', 'convers.'].indexOf(value) !== -1,
  isMotorcycle: (value) => ['motoneta', 'motocicleta'].indexOf(value) !== -1,
  isPickupOrTruck: (value) => ['caminhonete', 'caminhao', 'caminhao trator', 'mist/cam', 'car aberta', 'aberta/cabine dupla', 'c fechada', 'tanq/c est', 'aberta/cabine estendida', 'aber c.dup', 'tanque', 'basculante'].indexOf(value) !== -1,
  data: (item, keys) => {
    if (typeof keys === 'string') {
      return item[keys] || '';
    }
    for (const key of keys) {
      if (item[key]) {
        return item[key];
      }
    }
    return '';
  },
  getMarkupChassis: (value) => {
    if (value.baseNacional.tipoMarcacaoChassi) {
      return value.baseNacional.tipoMarcacaoChassi;
    }
    if (value.baseNacional.chassiRemarcado) {
      return 'REMARCADO';
    }
    return 'NORMAL';
  },
  getRenavam: (value) => {
    if (value.renavam) {
      return value.renavam;
    }
    if (value.baseEstadual?.renavam) {
      return value.baseEstadual.renavam;
    }
    if (value.baseNacional?.renavam) {
      return value.baseNacional.renavam;
    }
    if (value.historicoTransferencias && value.historicoTransferencias.length > 0) {
      return value.historicoTransferencias[0].renavam;
    }
    return 'Nada Consta';
  },
  getEngine: (value) => {
    if (value.numMotor) {
      return value.numMotor;
    }
    if (value.baseEstadual?.motor) {
      return value.baseEstadual.motor;
    }
    if (value.baseNacional?.motor) {
      return value.baseNacional.motor;
    }
    if (value.proprietarioAtual?.motor) {
      return value.proprietarioAtual.motor;
    }
    return 'Nada Consta';
  },
  getChassis: (value) => {
    if (value.chassi) {
      return value.chassi;
    }
    if (value.baseEstadual?.chassi) {
      return value.baseEstadual.chassi;
    }
    if (value.baseNacional?.chassi) {
      return value.baseNacional.chassi;
    }
    return 'Nada Consta';
  },
  hasRestrictionValue: (value) => {
    if (Array.isArray(value)) { return false; }
    const result = value ? extract.onlyNumbers(value) : 0;
    return result > 0;
  },
  hasRestriction: (value) => {
    if (Array.isArray(value)) { return false; }
    const result = value ? format.upper(extract.normalize(value)) : '';
    return result
      && result !== '-'
      && result !== '0,00'
      && result !== 'NAO'
      && result !== 'NAO HA'
      && result !== 'NAO EXISTE'
      && result !== 'SEM RESTRICAO'
      && result !== 'SEM GRAVAME'
      && result !== 'NADA CONSTA'
      && result !== 'VEICULO NAO POSSUI RESTRICAO'
      && result !== 'VEICULO COM INSPECAO VEICULAR OK'
      && result !== 'VEICULO COM INSPECAO VEICULAR \'OK\''
      && result.indexOf('NAO EXISTE DEBITO') === -1
      && result.indexOf('NAO CONSTA') === -1
      && result.indexOf('NAO EXISTE') === -1
      && result.indexOf('NADA CONSTA') === -1
      && result.indexOf('SEM OCORRENCIA') === -1
      && result.indexOf('SEM COMUNICA') === -1
      && result.indexOf('SEM RESTRI') === -1
      && result.indexOf('SEM MULTA') === -1
      && result.indexOf('SEM REGISTRO') === -1
      && result.indexOf('NAO INDICA') === -1;
  },
  hasAnyNationalRestriction: (value) => (
    value.baseNacional && (
      (value.resumo && report.hasRestriction(value.resumo.restricoesNacionaisEstaduais))
      || report.hasRestriction(value.baseNacional.indicadorComunicacaoVendas)
      || report.hasRestriction(value.baseNacional.indicadorComunicacaoVenda)
      || report.hasRestriction(value.baseNacional.indicadorRestricaoRenajud)
      || report.hasRestriction(value.baseNacional.indicadorRestricaoRenainf)
      || report.hasRestriction(value.baseNacional.restricaoFinanciadora)
      || report.hasRestriction(value.baseNacional.restricoes?.comunicacaoVenda)
      || report.hasRestriction(value.baseNacional.restricoes?.intencaoVenda)
      || report.hasRestriction(value.baseNacional.restricoes?.renainf)
      || report.hasRestriction(value.baseNacional.restricoes?.renajud)
      || report.hasRestriction(value.baseNacional.restricoes?.rfb)
      || report.hasRestriction(value.baseNacional.restricoes?.rouboFurto)
      || report.hasRestriction(value.baseNacional.ocorrencia)
      || report.hasRestriction(value.baseNacional.restricao1)
      || report.hasRestriction(value.baseNacional.restricao2)
      || report.hasRestriction(value.baseNacional.restricao3)
      || report.hasRestriction(value.baseNacional.restricao4)
    )
  ),
  hasAnyStateRestriction: (value) => (
    value.baseEstadual && (
      ((Array.isArray(value.baseEstadual.impedimentos) && value.baseEstadual.impedimentos?.length > 0) || report.hasRestriction(value.baseEstadual.impedimentos))
      || (value.resumo && report.hasRestriction(value.resumo.restricoesNacionaisEstaduais))
      || report.hasRestriction(value.baseEstadual.comunicacaoVenda)
      || report.hasRestriction(value.baseEstadual.restricaoAdminisrativa)
      || report.hasRestriction(value.baseEstadual.restricaoFinanceira)
      || report.hasRestriction(value.baseEstadual.restricaoGuincho)
      || report.hasRestriction(value.baseEstadual.restricaoJudicial)
      || report.hasRestriction(value.baseEstadual.restricaoAmbiental)
      || report.hasRestriction(value.baseEstadual.outrasRestricoes1)
      || report.hasRestriction(value.baseEstadual.outrasRestricoes2)
      || report.hasRestriction(value.baseEstadual.outrasRestricoes3)
      || report.hasRestriction(value.baseEstadual.outrasRestricoes4)
      || report.hasRestriction(value.baseEstadual.restricaoRenajud)
      || report.hasRestriction(value.baseEstadual.restricaoRouboFurto)
      || report.hasRestriction(value.baseEstadual.restricaoTributaria)
      || report.hasRestriction(value.baseEstadual.existeDebitoIpva)
      || report.hasRestriction(value.baseEstadual.existeDebitoLicenciamento)
      || report.hasRestriction(value.baseEstadual.existeDebitoMulta)
      || report.hasRestrictionValue(value.baseEstadual.debitoIpva)
      || report.hasRestrictionValue(value.baseEstadual.debitoMultas)
      || report.hasRestrictionValue(value.baseEstadual.debitoLicenciamento)
      || report.hasRestrictionValue(value.baseEstadual.debitoDpvat)
    )
  ),
  hasRemarkedChassis: (vehicle) => {
    let tipoMarcacaoChassi = 'NORMAL';
    if (vehicle.baseEstadual?.tipoMarcacaoChassi && vehicle.baseEstadual.tipoMarcacaoChassi !== tipoMarcacaoChassi) {
      tipoMarcacaoChassi = vehicle.baseEstadual.tipoMarcacaoChassi;
    } else if (vehicle.baseNacional?.tipoMarcacaoChassi && vehicle.baseNacional.tipoMarcacaoChassi !== tipoMarcacaoChassi) {
      tipoMarcacaoChassi = vehicle.baseNacional.tipoMarcacaoChassi;
    }
    tipoMarcacaoChassi = format.upper(extract.normalize(tipoMarcacaoChassi));
    return tipoMarcacaoChassi !== 'NORMAL' && tipoMarcacaoChassi !== 'N' && tipoMarcacaoChassi !== 'NAO' && tipoMarcacaoChassi !== 'NAO INFORMADO';
  },
  hasMultas: (value) => (value.multasRenainf && value.multasRenainf.length > 0) || (value.renajuds && value.renajuds.length > 0),
  hasPhotos: (value) => value.anuncio?.fotos && value.anuncio.fotos.length > 0,
  hasRenainf: (value) => (value.multasRenainf && value.multasRenainf.length > 0) || (value.multas && value.multas.length > 0),
  hasRenajuds: (value) => {
    if (!value.renajuds || value.renajuds.length === 0) {
      return false;
    }
    for (const renajud of value.renajuds) {
      if (report.hasRestriction(renajud.detalheRenajud)) {
        return true;
      }
    }
    return false;
  },
  hasGravame: (value) => {
    if (!value.gravame || value.gravame.length === 0) {
      return false;
    }
    const result = value.gravame.filter((element) => element.situacao && element.situacao.indexOf('GRAVAME BAIXADO') === -1 && element.situacao.indexOf('GRAVAME CANCELADO') === -1 && element.situacao.indexOf('SEM RESTRICOES') === -1);
    return result.length > 0;
  },
  hasRecall: (value) => value.recall?.detalhes && value.recall.detalhes.length > 0,
  hasHistoricoKM: (value) => value.historicoKm && value.historicoKm.length > 0,
  hasHistoricoProprietarios: (value) => value.historicoProprietarios && value.historicoProprietarios.length > 0,
  hasRouboFurto: (value) => value.rouboFurto?.historico && value.rouboFurto.historico.length > 0,
  hasIndicioSinistro: (value) => {
    if (!value.indicioSinistro?.descricao) {
      return false;
    }
    const descricao = format.upper(extract.normalize(value.indicioSinistro.descricao));
    return descricao.indexOf('NAO CONSTA SINISTRO') === -1 && descricao.indexOf('NAO CONSTA INDICIO DE SINISTRO') === -1 && descricao.indexOf('NAO EXISTE REGISTRO DE INDICIO DE SINISTRO') === -1;
  },
  hasLeilao: (value) => (value.leilao?.registros && value.leilao.registros.length > 0) || (value.leilao4Corp?.registros && value.leilao4Corp.registros.length > 0),
  hasAlteracaoMotor: (value) => {
    if (!value.numMotor && !value.baseEstadual?.motor && !value.baseNacional?.motor) { return false; }
    const engineNumber = `${value.numMotor || value.motor || value.baseEstadual?.motor || value.baseNacional?.motor}`.replace(/[^\w\s]/gi, '');
    const engineNumberState = value.baseEstadual?.motor;
    const engineNumberNational = value.baseNacional?.motor;
    if (engineNumberState && engineNumberNational) {
      return engineNumberState.replace(/[^\w\s]/gi, '') !== engineNumberNational.replace(/[^\w\s]/gi, '');
    }
    if (engineNumberState) {
      return engineNumber !== engineNumberState.replace(/[^\w\s]/gi, '');
    }
    if (engineNumberNational) {
      return engineNumber !== engineNumberNational.replace(/[^\w\s]/gi, '');
    }
    return false;
  },
  hasError: (vehicle, value) => !value || (vehicle.mensagemRetorno && (vehicle.mensagemRetorno.indexOf('Nenhum veículo foi encontrado para a placa') !== -1 || vehicle.mensagemRetorno.indexOf('Veículo não encontrado') !== -1 || vehicle.mensagemRetorno.indexOf('Placa inválida') !== -1)),
  hide: (config, key) => config?.hide?.some((e) => e === key),
  restrictionColor: (value) => report.hasRestriction(value) ? ' text-danger' : '',
  restrictionValueColor: (value) => Number.parseFloat(value) > 0 ? ' text-danger' : '',
  currencyValue: (value) => value ? `R$ ${value}` : 'R$ 0,00',
  getValue: (vehicle) => {
    if (vehicle.decodificadorPrecificador?.precificadorI && vehicle.decodificadorPrecificador.precificadorI.length > 0) {
      return format.currency(vehicle.decodificadorPrecificador.precificadorI[0].valor);
    }
    if (vehicle.dadosBasicosDoVeiculo?.informacoesFipe?.length === 1) {
      const fipe = vehicle.dadosBasicosDoVeiculo.informacoesFipe[0];
      return format.currency(fipe.valorAtual);
    }
    if (vehicle.fipe?.dados?.length === 1) {
      const fipe = vehicle.fipe.dados[0];
      return format.currency(fipe.texto_valor);
    }
    return '';
  },
  getZeroKmValue: (vehicle) => {
    if (vehicle.decodificadorPrecificador?.precificadorI && vehicle.decodificadorPrecificador.precificadorI.length > 0) {
      return format.currency(vehicle.decodificadorPrecificador.precificadorI[0].valorZeroKM);
    }
    return 'NADA CONSTA';
  },
  getMarketValue: (vehicle) => {
    if (vehicle.decodificadorPrecificador?.precificadorII && vehicle.decodificadorPrecificador.precificadorII.length > 0) {
      return format.currency(vehicle.decodificadorPrecificador.precificadorII[0].valor);
    }
    return 'NADA CONSTA';
  },
  getOrigin: (vehicle) => {
    let result = '';
    const extract = (data) => {
      const municipio = data.municipio;
      const uf = data.uf;
      if (municipio.includes('-') && municipio.trim().split('-')[1].length === 2) {
        return municipio.replace('-', '/');
      }
      return `${municipio}/${uf}`;
    };
    if (vehicle.baseEstadual) {
      result = extract(vehicle.baseEstadual);
    }
    if (!result && vehicle.baseNacional) {
      return extract(vehicle.baseNacional);
    }
    if (!result) {
      result = extract(vehicle);
    }
    return result || 'NADA CONSTA';
  },
};

report.applyUrlFilters = applyUrlFilters;
report.resolveHideKeys = resolveHideKeys;
